// extracted by mini-css-extract-plugin
module.exports = {"loginMain":"Login_loginMain__2r38P","loginHeader":"Login_loginHeader__23b-A","loginWithGoogle":"Login_loginWithGoogle__18HxR","google":"Login_google__3Fppj"};